import dayjs from 'dayjs';

const getters = {
    // Inspection
    hasTenancyInspectionDate: (state) => {
        return Boolean(state.tenancy.InspectionDate);
    },
    parsedTenancyInspectionExpiryDate: (state) => {
        return dayjs(state.tenancy.InspectionDate);
    },

    // Vacating Date
    hasVacatingDate: (state) => {
        return Boolean(state.tenancy.dteVacatingDate);
    },
    parsedVacatingExpiryDate: (state) => {
        return dayjs(state.tenancy.dteVacatingDate);
    },

    // Renewal Date
    hasRenewalDate: (state) => {
        return Boolean(state.tenancy.dteRenewalDate);
    },
    parsedRenewalExpiryDate: (state) => {
        return dayjs(state.tenancy.dteRenewalDate);
    },
};

export default getters;
